/*cc webapp framework
 *author: Jonathan 'JK' Kernick
 *description: the classes and functions required to build a web app
 */

//if there is no CC 'namespace' then create one
if (typeof CC === "undefined") {
    var CC = {dummy: "dummy"};
    CC.isMobile = navigator.userAgent.match(/BlackBerry|Windows Phone|Android|iPad|iPhone|Silk|iPod|Kindle|Nexus/i) !== null;
}

/*constructor for a web app
 domContainer: a DOM object like a div that the web app will be contained in
 initWidth: the init width of the canvas can change depending on resize method
 initHeight: the init Height of the canvas can change depending on resize method
 resizeMethod: the method of resizing defualt is NO_REISIZE
 backgroundColor:
 */

CC.WebApp = function (domContainer, initWidth, initHeight, resizeMethod, backgroundColor, assetURL) {
    //sets defualts
    //if no container then its asumed body is the container
    this.domContainer = domContainer || document.body;
    //if no init width set then asume 960
    this.screenWidth = initWidth || 960;
    this.cssEnabled = false;
    this.screenWidthMax = initWidth || 960;
    this.screenWidthMin = initWidth || 960;
    this.screenHeightMax = initHeight || 640;
    this.screenHeightMin = initHeight || 640;
    //if no init height set then asume 720
    this.screenHeight = initHeight || 720;
    //if no resize method then asume no resize
    this.resizeMethod = resizeMethod || CC.WebApp.Resizer.NO_RESIZE;
    //if no background color then asume white
    this.backgroundColor = backgroundColor || 0xFFFFFF;
    //if no asset url set then asume ''
    this.assetURL = assetURL || '';
    //sets the web app static to the current instance
    CC.WebApp.current = this;


}
CC.WebApp.current = false;
//sets up the class prototype propertys
CC.WebApp.prototype =
{
    //-------------------object properys
    domContainer: 'No DOM Object Defined',
    screenWidth: 'No WIDTH Defined',
    screenHeight: 'No HEIGHT Defined',
    screenOffsetY: 0,
    scaledWidth: 'No WIDTH Defined',
    scaledHeight: 'No HEIGHT Defined',
    resizeMethod: 'No RESIZE METHOD Defined',
    backgroundColor: 'NO BACKGROUND COLOUR  Defined',
    backgroundObject: 'NO BACKGROUND Object  Defined',
    backgroundGraphic: 'NO BACKGROUND Graphic  Defined',
    renderer: 'No RENDER  Defined',
    stage: 'No RENDER  Defined',
    runUpdate: true,
    //----------------web app running propertys
    //time stamps that mark the current frame and last frame, for calculating how much time has passed
    currentTimeStamp: 0,
    previousTimeStamp: 0,
    //this is stored so we know that the dimentions have changed
    oldInnerWidth: 0,
    oldInnerHeight: 0,
    oldWindowInnerWidth: 0,
    oldWindowInnerHeight: 0,
    forceResize: false,
    //seconds elapsed since last frame
    elapsedSeconds: 0,
    //the ratio of screenWidth/screenHeight
    ratio: 0,
};
//function builds the canvas and creates the stage
CC.WebApp.prototype.init = function (forceCanvas) {
    //sets up render and apends to dom object
    if (forceCanvas) {
        this.renderer = new PIXI.CanvasRenderer(this.screenWidth, this.screenHeight);
    }
    else {
        this.renderer = new PIXI.autoDetectRenderer(this.screenWidth, this.screenHeight, {antialias: false});
    }
    this.domContainer.appendChild(this.renderer.view);
    //creates the display stage
    this.stage = new PIXI.Container();
    //creates resize event
    var self = this;
    var resizeForceFunc = function () {
        self.forceResize = true;
    }
    //sets up resizeFunctions for orientation change or resize call
    window.addEventListener('orientationchange', resizeForceFunc);
    window.addEventListener('resize', resizeForceFunc);
}
//function to stop the render from ticking over
CC.WebApp.prototype.pause = function () {
    //stops the main loop from reRendering.
    this.loopActive = false;
}
//a quick function to build the canvas and start the render loop.
CC.WebApp.prototype.firstStart = function (screenObject, forcedCanvas) {
    this.init(forcedCanvas);
    this.start(screenObject);
}
//a function to resize the screen and set the correct values
CC.WebApp.prototype.reSize = function (width, height) {
    this.renderer.resize(width, height);
    this.drawBackgroundColor(width,height);
    this.screenWidth = width;
    this.screenHeight = height;
    //recenters the screen object with the new values
    this.screenObject.construct.position.x = Math.floor(this.screenWidth * 0.5);
    this.screenObject.construct.position.y = Math.floor(((this.screenHeight * 0.5) + this.screenOffsetY));

}
//function to start the render loop, this will not start the canvas.
CC.WebApp.prototype.start = function (screenObject) {
    //checks to make sure you didn't try to call this while its already running.
    if (!this.loopActive) {
        //starts the canvas back up again.

        //sets the loopActive to true.
        this.loopActive = true;
        //if a screen object was provided then set that as the current screen
        if (screenObject) {
            this.swapScreen(screenObject);
        }

        //sets the current time stamp to whatever because if we don't it will tween from 1970s to now.
        this.previousTimeStamp = new Date().getTime();
        //request the animator to start.
        var self = this;
        requestAnimationFrame(function () {
            self.mainLoop()
        });
        //dirty the stage
        this.dirty();
    }
}
//function to set the background colour takes a hex value
CC.WebApp.prototype.setBackgroundColor = function (newbackgroundColor) {
    //creates a background graphics
    var newGraphic = new PIXI.Graphics();;
    //switches the backgrouned colour
    if (this.backgroundObject.children.length > 0) {
        this.backgroundObject.removeChild(this.backgroundGraphic);
    }
    this.backgroundObject.addChild(newGraphic);
    this.backgroundGraphic = newGraphic;
    this.backgroundColour = newbackgroundColor;
    
    this.drawBackgroundColor(this.screenWidth || 100,this.screenHeight || 100);

    // this.stage.setBackgroundColor(newbackgroundColor);
};
//function to set the background colour takes a hex value
CC.WebApp.prototype.drawBackgroundColor = function (width,height) {
    this.backgroundGraphic.clear();
    this.backgroundGraphic.beginFill(this.backgroundColour);
    this.backgroundGraphic.drawRect(0, 0, width, height);
    this.backgroundGraphic.endFill();
};
//function to dirty the stage
CC.WebApp.prototype.dirty = function () {
    this.stage.dirty = true;
};
//canvas resizing method used to resize the canvas
CC.WebApp.prototype.matchAspectRatio = function (resizeTheWidthBool) {
    if (resizeTheWidthBool) {
        //resizes the screen width to match aspect ratio
        this.screenWidth = Math.ceil((this.screenHeight / this.domContainer.offsetHeight) * this.domContainer.offsetWidth);
        this.screenWidth = Math.min(this.screenWidthMax, this.screenWidth);
        this.screenWidth = Math.max(this.screenWidthMin, this.screenWidth);
    }
    else {
        //resizes the screen height to match aspect ratio
        this.screenHeight = Math.ceil((this.screenWidth / this.domContainer.offsetWidth) * this.domContainer.offsetHeight);
        this.screenHeight = Math.min(this.screenHeightMax, this.screenHeight);
        this.screenHeight = Math.max(this.screenHeightMin, this.screenHeight);
    }

    //resizes the canvas propper with the new values
    this.renderer.resize(this.screenWidth, this.screenHeight);
    this.drawBackgroundColor(this.screenWidth,this.screenHeight);

    //recenters the screen object with the new values
    this.screenObject.construct.position.x = Math.floor(this.screenWidth * 0.5);
    this.screenObject.construct.position.y = Math.floor(((this.screenHeight * 0.5) + this.screenOffsetY));
    //stuffs changed dirty the stage
    this.stage.dirty = true;

}
//function swaps the canvas objects
CC.WebApp.prototype.mainLoop = function () {
    var self = this;
    //if the loopActive is still true then request another frame
    if (this.loopActive) {
        requestAnimationFrame(function () {
            self.mainLoop()
        });
    }
    //stamps the current time
    this.currentTimeStamp = new Date().getTime();

    //calculates the seconds that have elapsed since last checking
    this.elapsedSeconds = (this.currentTimeStamp - this.previousTimeStamp) / 1000;

    //if there has been a changed in the containers width and height then the canvas must be changed
    if ((this.oldInnerWidth !== this.domContainer.offsetWidth ||
        this.oldInnerHeight !== this.domContainer.offsetHeight ||
        this.oldWindowInnerWidth !== window.innerWidth ||
        this.oldWindowInnerHeight !== window.innerHeight || forceResize) && this.resizeMethod !== CC.WebApp.Resizer.NO_RESIZE) {
        //assigns the new sizes to the object so we know what the last sizes were
        this.oldInnerWidth = this.domContainer.offsetWidth;
        this.oldInnerHeight = this.domContainer.offsetHeight;
        this.oldWindowInnerWidth = window.innerWidth;
        this.oldWindowInnerHeight = window.innerHeight;
        if (this.domContainer.offsetWidth < window.innerWidth) {
            var maxWidth = this.domContainer.offsetWidth;
            var maxHeight = this.domContainer.offsetHeight;
        }
        else {
            var maxWidth = window.innerWidth;
            var maxHeight = window.innerHeight;
        }
        forceResize = false;
        //uses the resize method if the width has to be changed
        if (this.resizeMethod === CC.WebApp.Resizer.FLEX_WIDTH) {
            this.matchAspectRatio(true);
        }
        //uses the resize method if the height has to be changed
        if (this.resizeMethod === CC.WebApp.Resizer.FLEX_HEIGHT) {
            this.matchAspectRatio(false);
        }
        //init the scaledWidth with the actual width
        this.scaledWidth = this.screenWidth;
        //init the scaledHeight with the actual height
        this.scaledHeight = this.screenHeight;

        //we only need to know this ratio stuff if we are going to have it fixed on the resize
        if (this.resizeMethod === CC.WebApp.Resizer.FLEX_WIDTH || this.resizeMethod === CC.WebApp.Resizer.FIXED_RATIO) {
            //calculates the ratio so we know how much the width should be to the height
            this.ratio = this.screenWidth / this.screenHeight;
            if (this.oldInnerHeight * this.ratio < this.oldInnerWidth) {
                this.scaledWidth = (maxHeight * this.ratio);
                this.scaledHeight = (maxHeight);
            }
            else {
                this.scaledWidth = (maxWidth);
                this.scaledHeight = (maxWidth / this.ratio);
            }
        }

        //if the resize method is matching aspect ratio then the container is the width and height so it can match them exsactly
        if (this.resizeMethod === CC.WebApp.Resizer.FLEX_HEIGHT) {
            //calculates the ratio so we know how much the width should be to the height
            this.ratio = this.screenWidth / this.screenHeight;
            if (this.oldInnerHeight * this.ratio < this.oldInnerWidth) {
                this.scaledWidth = (maxHeight * this.ratio);
                this.scaledHeight = (maxHeight);
            }
            else {
                this.scaledWidth = (maxWidth);
                this.scaledHeight = (maxWidth / this.ratio);
            }
        }

        //this always needs to be done because the resize method might have changed
        if (this.cssEnabled) {
            this.renderer.view.style.width = this.scaledWidth + 'px';
            this.renderer.view.style.height = this.scaledHeight + 'px';


        /*    if (this.resizeMethod === CC.WebApp.Resizer.FLEX_WIDTH ||
                this.resizeMethod === CC.WebApp.Resizer.FLEX_HEIGHT) {
                //if the current resize method matches aspect ratio like the above do there is no point resizing them
                this.renderer.view.style.left = '0px';
                this.renderer.view.style.top = '0px';
            }
            else*/ {
                //if the current method does not match the aspect it will need to be centered
                this.renderer.view.style.left = ((this.oldInnerWidth - this.scaledWidth) * 0.5) + 'px';
                this.renderer.view.style.top = ((this.oldInnerHeight - this.scaledHeight) * 0.5) + 'px';
                this.renderer.view.style.position = "relative";// = ((this.oldInnerHeight-this.scaledHeight)*0.5)+'px';
            }
        }
        //if this object has a resized function then run it
        if (this.screenObject && this.screenObject.resize) {
            this.screenObject.resize(this.screenWidth, this.screenHeight);
        }
    }

    /* update dragonbones animation */
    if (this.runUpdate && typeof dragonBones !== "undefined") {
        dragonBones.animation.WorldClock.clock.advanceTime(this.elapsedSeconds);
    }
    //if this object has an update function then run it
    if (this.runUpdate && this.screenObject && this.screenObject.update) {
        this.screenObject.update(this.elapsedSeconds);
    }
    /* if(window.innerWidth > window.innerHeight)
     {
     window.containerDom.style.height = "100%";
     }
     else
     {
     window.containerDom.style.height = "50%";
     }*/
    //ok lets render this bad boy to that canvas!
    this.renderer.render(this.stage);
    //ok move the time stamp so the next elaps can be calulated
    this.previousTimeStamp = this.currentTimeStamp;
}
//function returns a png of the current screen
CC.WebApp.prototype.printScreen = function () {
    //take a snapshot of the url
    return this.renderer.view.toDataURL();
};
CC.WebApp.prototype.resumeUpdate = function () {
    this.runUpdate = true;
    PIXI.spine.Spine.globalAutoUpdate = true;
    PIXI.ticker.shared.start();
};
CC.WebApp.prototype.pauseUpdate = function () {
    this.runUpdate = false;
    PIXI.spine.Spine.globalAutoUpdate = false;
    PIXI.ticker.shared.stop();
};
CC.WebApp.prototype.createScreenSprite = function () {
    var printSCreenPng = this.printScreen();
    return new PIXI.Sprite.fromImage(printSCreenPng, true);
}
//function swaps the canvas objects
CC.WebApp.prototype.swapScreen = function (newScreenObject, transitionEffect, transitionTime, transitionColor) {
    //any last words? runs a method at each screen destruction
    if (this.screenObject && this.screenObject.end) {
        this.screenObject.end(this.elapsedSeconds);
    }

    //valid transition effects ['none','fade','zoomfade0,'panright','panleft']
    transitionEffect = transitionEffect || 'none';
    //transition time defaults to 1
    if (transitionTime != undefined) {
        transitionTime = 1;
    }
    //transition time defaults to 1
    transitionColor = transitionColor || 0x000000;

    this.screenSpriteObject = null;
    if (typeof(TweenLite) !== 'undefined' && !CC.isMobile) {
        switch (transitionEffect) {
            case 'none':
                //do nothing here because none
                break;
            case 'fade':
            case 'fadezoom':
            case 'faderight':
            case 'fadeleft':
            case 'fadedown':
            case 'fadeup':
            case 'panright':
            case 'panleft':
            case 'pandown':
            case 'panup':
            case 'faderotateleft':
            case 'faderotateright':
            case 'scrollright':
            case 'scrollleft':
            case 'scrolldown':
            case 'scrollup':
                this.screenSpriteObject = this.createScreenSprite();
                this.screenSpriteObject.anchor.x = 0.5;
                this.screenSpriteObject.anchor.y = 0.5;
                this.screenSpriteObject.position.x = Math.floor(this.screenWidth * 0.5);
                this.screenSpriteObject.position.y = Math.floor(this.screenHeight * 0.5);
                break;
        }
    }
    var self = this;
    var swapScreenPropper = function () {
        //ravage the current stage... leave none alive!
        if (self.stage.children.length > 0) {
            CC.WebApp.deconstructDisplayObjects(self.stage);
        }
        //create a new background object
        self.backgroundObject = new PIXI.Container();
        //assigns the new screen object
        self.screenObject = newScreenObject;
        if (self.screenObject && self.screenObject.color !== undefined) {
            self.setBackgroundColor(self.screenObject.color);
        }
        else {
            self.setBackgroundColor(self.backgroundColor);
        }

        //add the backgroundColour!!!
        self.stage.addChild(self.backgroundObject);
        //appends the new screen object
        self.stage.addChild(self.screenObject.construct);

        //sets the screen objects position to the middle
        self.screenObject.construct.position.x = Math.floor(self.screenWidth * 0.5);
        self.screenObject.construct.position.y = Math.floor(((self.screenHeight * 0.5) + self.screenOffsetY));
        //add the old screen for transitionEffect if tweenlite is loaded
        if (typeof(TweenLite) !== 'undefined' && self.screenSpriteObject !== null) {
            self.stage.addChild(self.screenSpriteObject);
            switch (transitionEffect) {
                case 'fade':
                    TweenLite.to(self.screenSpriteObject, transitionTime, {
                        alpha: 0, onComplete: function () {
                            self.screenSpriteObject.visible = false;
                        }
                    });
                    break;
                case 'faderotateleft':
                    TweenLite.to(self.screenSpriteObject.scale, transitionTime, {x: 1.5, y: 1.5});
                    TweenLite.to(self.screenSpriteObject, transitionTime, {rotation: -0.4});
                    TweenLite.to(self.screenSpriteObject, transitionTime, {
                        alpha: 0, onComplete: function () {
                            self.screenSpriteObject.visible = false;
                        }
                    });
                    break;
                case 'faderotateright':
                    TweenLite.to(self.screenSpriteObject.scale, transitionTime, {x: 1.5, y: 1.5});
                    TweenLite.to(self.screenSpriteObject, transitionTime, {rotation: 0.4});
                    TweenLite.to(self.screenSpriteObject, transitionTime, {
                        alpha: 0, onComplete: function () {
                            self.screenSpriteObject.visible = false;
                        }
                    });
                    break;
                case 'fadezoom':
                    TweenLite.to(self.screenSpriteObject.scale, transitionTime, {x: 1.5, y: 1.5});
                    TweenLite.to(self.screenSpriteObject, transitionTime, {
                        alpha: 0, onComplete: function () {
                            self.screenSpriteObject.visible = false;
                        }
                    });
                    break;
                case 'fadeup':
                    TweenLite.to(self.screenSpriteObject.position, transitionTime, {y: screenSpriteObject.position.y - 200});
                    TweenLite.to(self.screenSpriteObject, transitionTime, {
                        alpha: 0, onComplete: function () {
                            self.screenSpriteObject.visible = false;
                        }
                    });
                    break;
                case 'fadedown':
                    TweenLite.to(self.screenSpriteObject.position, transitionTime, {y: (screenSpriteObject.position.y + 200)});
                    TweenLite.to(self.screenSpriteObject, transitionTime, {
                        alpha: 0, onComplete: function () {
                            self.screenSpriteObject.visible = false;
                        }
                    });
                    break;
                case 'fadeleft':
                    TweenLite.to(self.screenSpriteObject.position, transitionTime, {x: screenSpriteObject.position.x - 200});
                    TweenLite.to(self.screenSpriteObject, transitionTime, {
                        alpha: 0, onComplete: function () {
                            self.screenSpriteObject.visible = false;
                        }
                    });
                    break;
                case 'faderight':
                    TweenLite.to(self.screenSpriteObject.position, transitionTime, {x: (screenSpriteObject.position.x + 200)});
                    TweenLite.to(self.screenSpriteObject, transitionTime, {
                        alpha: 0, onComplete: function () {
                            self.screenSpriteObject.visible = false;
                        }
                    });
                    break;
                case 'panleft':
                    TweenLite.from(self.screenObject.construct.position, transitionTime, {
                        x: self.screenWidth * 1.5, ease: Circ.easeOut, onUpdate: function () {
                            self.screenSpriteObject.position.x = self.screenObject.construct.position.x - self.screenWidth;
                        }
                    });
                    break;
                case 'panright':
                    TweenLite.from(self.screenObject.construct.position, transitionTime, {
                        x: self.screenWidth * -0.5, ease: Circ.easeOut, onUpdate: function () {
                            self.screenSpriteObject.position.x = (self.screenObject.construct.position.x + self.screenWidth);
                        }
                    });
                    break;
                case 'pandown':
                    TweenLite.from(self.screenObject.construct.position, transitionTime, {
                        y: self.screenHeight * 1.5, ease: Circ.easeOut, onUpdate: function () {
                            self.screenSpriteObject.position.y = self.screenObject.construct.position.y - self.screenHeight;
                        }
                    });
                    break;
                case 'panup':
                    TweenLite.from(self.screenObject.construct.position, transitionTime, {
                        y: self.screenHeight * -0.5, ease: Circ.easeOut, onUpdate: function () {
                            self.screenSpriteObject.position.y = (self.screenObject.construct.position.y + self.screenHeight);
                        }
                    });
                case 'scrollleft':
                    TweenLite.to(self.screenSpriteObject.position, transitionTime, {
                        x: self.screenWidth * 0.5,
                        ease: Circ.easeInOut
                    });
                    break;
                case 'scrollright':
                    TweenLite.to(self.screenSpriteObject.position, transitionTime, {
                        x: self.screenWidth * 1.5,
                        ease: Circ.easeInOut
                    });
                    break;
                case 'scrollup':
                    TweenLite.to(self.screenSpriteObject.position, transitionTime, {
                        y: self.screenHeight * 0.5,
                        ease: Circ.easeOut
                    });
                    break;
                case 'scrolldown':
                    TweenLite.to(self.screenSpriteObject.position, transitionTime, {
                        y: self.screenHeight * 1.5,
                        ease: Circ.easeInOut
                    });
                    break;
            }

        }
        //sets the stage to dirty so it gets reRendered
        self.stage.dirty = true;
    }

    if (this.screenSpriteObject !== null) {
        this.screenSpriteObject.texture.baseTexture.source.onload = function () {
            setTimeout(function () {
                swapScreenPropper()
            }, 100)
        };
    }
    else {
        swapScreenPropper();
    }
}

//const for the resing might made them strings for better understanding.
CC.WebApp.Resizer = {
    NO_RESIZE: 0, //don't resize the canvas or the scale
    FIXED_RATIO: 1, //don't resize the canvas but scale to fit
    FLEX_WIDTH: 2, // resize the canvas width to match ratio and scale to fit
    FLEX_HEIGHT: 3, // resize the canvas height to match ratio and scale to fit
}
//static function for dismantling the a display object
CC.WebApp.deconstructDisplayObjects = function (displayObject) {
    //for every child of this object
    for (var i = displayObject.children.length - 1; i >= 0; --i) {
        //if they have no protection on them
        if (!displayObject.children[i].protect) {
            //and have there own children
            if (displayObject.children[i].children.length > 0) {
                //then destory them as well
                CC.WebApp.deconstructDisplayObjects(displayObject.children[i]);
            }
            //once thats checked and done remove the child
            displayObject.removeChild(displayObject.children[i]);
        }
    }
}
